export default "<article>\n    <app-key-value-add></app-key-value-add>\n    <app-key-value-table [items]=\"items\"></app-key-value-table>\n</article>"